export default __webpack_public_path__ + "images/ae2087a3922088a93b0f3fde77c0e56f.svg";